<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mLAhLQ/tc-custom/9781467422932.jpg?1742011080414" alt="This image is the cover for the book The Books of Numbers, New International Commentary on the Old Testament (NICOT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Books of Numbers, New International Commentary on the Old Testament (NICOT)
      </h1>
      <p class="bookDescription body article font2">
        <p>The  book of Numbers tells a story that has  two main characters -- God and Israel.  The way the story is told sounds odd and  often harsh to readers today. In spite  of the difficulties imposed by Numbers  on today's readers, the main point of  the book is of immense importance for  God's people in any age: exact obedience  to God is crucial.<br/><br/>This  comprehensive and erudite commentary --  resulting from nearly a decade of study  of Numbers by Timothy Ashley -- presents  a thorough explication of this  significant Hebrew text. Ashley's  introduction to Numbers discusses such  questions as structure, authorship, and  theological themes, and it features an  extended bibliography of major works on  the book of Numbers, concentrating  mainly on works in English, French, and  German.<br/><br/>Dividing the text of  Numbers into five major sections,  Ashley's commentary elucidates the  theological themes of obedience and  disobedience that run throughout the  book's narrative. His detailed  verse-by-verse comments are intended  primarily to explain the Hebrew text of  Numbers as we have it rather than to  speculate on how the book came to be in  its present form.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy R. Ashley
      </h2>
      
      <p class="authorDescription body article">Timothy R. Ashley is minister of First Baptist Church in La Crosse, Wisconsin. He previously served for more than twenty years as professor of biblical studies at Acadia Divinity College in Wolfville, Nova Scotia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e2c8e86